<template lang="pug">
div.padding.p-t-0
    report-filter(
        @onOutletChange="applyOutletFilter",
        @onDateChange="applyDateFilter"
    )
        template(slot="title") Stock Receive

    div.row
        div.col-md-12
            div.box
                v-server-table(
                    :url="api",
                    :name="tableName",
                    ref="datatable",
                    :columns="columns",
                    :options="options"
                )
                    template(slot="status" slot-scope="props")
                        span.label.green(v-if="props.row.status == 1") Completed
                        span.label.yellow(v-else) In Progress
</template>

<script>
const TableName = 'VUETABLE_STOCK_RETURNS';
const exportUrl = 'stock_receives.exportData';
import Event from './stock-receive-event';

export default {
    data() {
        var that = this;

        return {
            tableName: TableName,
            columns: [
                'reference_id',
                'name',
                'outlet',
                'supplier',
                'receive_date',
                'receive_stocks',
                'status',
            ],
            options: {
                columnsClasses: {
                    receive_stocks: 'text-center',
                },
                permission: {
                    create: () => this.permission.SAVE_STOCK_RECEIVE,
                    delete: () => this.permission.DELETE_STOCK_RECEIVE,
                },
                checkbox: {
                    delete_title: 'Delete Stock Receive',
                    api_delete: Laroute.route('stock_receives.delete'),
                },
                checkboxDisableCallback: row => {
                    return row.status >= 1;
                },
                create_btn: {
                    title: 'New Stock Receive',
                    action: () => {
                        that.showCreateForm();
                    },
                },
                customFilters: ['status', 'outlet_id', 'since', 'until'],
                initFilters: {
                    outlet_id: this.$store.getters.activeOutlet,
                },
                orderBy: {
                    ascending: false,
                    column: 'reference_id',
                },
                rowClassCallback: row => 'pointer',
                rowClickCallback: that.showForm,
                templates: {
                    receive_date: (h, row) => {
                        return this.formattedDate(row.receive_date);
                    },
                },
                pdf_url: Laroute.route(exportUrl, { type: 'PDF' }),
                csv_url: Laroute.route(exportUrl, { type: 'CSV' }),
                xls_url: Laroute.route(exportUrl, { type: 'XLSX' }),
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('stock_receives.index');
        },
    },

    mounted() {
        Event.$on('stock-receive-saved', () => {
            this.$refs.datatable.getData();
        });
    },

    methods: {
        showForm(row) {
            this.$router.push(`/${row.id}`);
        },

        showCreateForm() {
            this.$router.push(`/create`);
        },

        applyOutletFilter(outlet) {
            this.$refs.datatable.applyOutletFilter(outlet);
        },

        applyDateFilter(date) {
            this.$refs.datatable.applyDateFilter(date);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_receive/stock-receive-list.vue